import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ChannelRentalAVGRatingItem } from '@tokeet-frontend/reviews'

@Component({
  selector: 'app-rental-review-insights-dialog',
  templateUrl: './rental-review-insights-dialog.component.html',
  styleUrls: ['./rental-review-insights-dialog.component.scss'],
})
export class RentalReviewInsightsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<RentalReviewInsightsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rentalId: string; rentalAverageOverallRating: ChannelRentalAVGRatingItem[] }
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close()
  }
}
